export type CategorySlug = "hot-gossip" | "variety" | "screen" | "influencer";

export interface Category {
  slug: CategorySlug;
  name: string;
  desc: string;
  icon: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: CategorySlug;
  categoryName: string;
  author: string;
  date: string;
  time: string;
  readTime: string;
  image: string;
  tags: string[];
  content: string[];
  featured?: boolean;
}

export const categories: Category[] = [
  {
    slug: "hot-gossip",
    name: "明星八卦",
    desc: "艺人行程、感情动态与合作花絮，第一时间跟进。",
    icon: "ri-user-star-line",
  },
  {
    slug: "variety",
    name: "综艺爆料",
    desc: "节目录制路透、嘉宾阵容与赛制风向，逐期解读。",
    icon: "ri-live-line",
  },
  {
    slug: "screen",
    name: "影视动态",
    desc: "新剧开机、定档消息与幕后制作，追剧不迷路。",
    icon: "ri-film-line",
  },
  {
    slug: "influencer",
    name: "网红热榜",
    desc: "短视频话题、直播名场面与达人涨粉动向。",
    icon: "ri-fire-line",
  },
];

export const articles: Article[] = [
  {
    id: "a1",
    title: "江迟苏念同框路透流出，新剧片场互动自然被赞默契十足",
    excerpt:
      "有网友在横店片场拍到江迟与苏念连续三天同框拍摄，两人候场时对台词、递水的细节被镜头记录，迅速登上今日热议榜首位。",
    category: "screen",
    categoryName: "影视动态",
    author: "瓜田观察员",
    date: "2026-09-10",
    time: "09:12",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=two%20chinese%20actors%20in%20period%20costume%20rehearsing%20on%20a%20film%20set%2C%20warm%20golden%20afternoon%20light%2C%20cinematic%20documentary%20photography%2C%20soft%20bokeh%20background%2C%20elegant%20warm%20color%20grading&width=1200&height=800&seq=guachi-a1&orientation=landscape",
    tags: ["路透", "新剧", "片场"],
    featured: true,
    content: [
      "今天上午，一组来自横店片场的高清路透在社交平台快速扩散。画面里，江迟与苏念穿着戏服在监视器旁对台词，工作人员递上水杯时两人互相谦让，整个人的状态相当松弛。",
      "据现场工作人员透露，这部新剧已经进入密集拍摄阶段，江迟与苏念的对手戏占了全剧近六成。为了贴合角色，两人提前两周进组围读剧本，连走位都反复确认细节。",
      "有追组粉丝表示，两人候场时几乎不玩手机，更多是讨论台词节奏和情绪层次，这种「戏比人先到」的工作方式在近年的剧组里并不多见。",
      "目前片方尚未公布正式剧照，但从路透的口碑来看，观众对这对组合的期待值已经被拉得很高。后续定档信息，「独家吃瓜」将持续跟进。",
    ],
  },
  {
    id: "a2",
    title: "《一起去远方》第三季阵容曝光，六位嘉宾风格反差拉满",
    excerpt:
      "旅行真人秀《一起去远方》第三季录制名单疑似曝光，节目组这次把「慢综艺」和「任务挑战」结合，嘉宾组合被网友称为近年最有看点的一次。",
    category: "variety",
    categoryName: "综艺爆料",
    author: "综艺情报站",
    date: "2026-09-10",
    time: "08:40",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=travel%20reality%20show%20team%20walking%20on%20a%20mountain%20trail%20at%20sunrise%2C%20wide%20cinematic%20shot%2C%20warm%20amber%20tones%2C%20documentary%20style%2C%20soft%20mist%20in%20valley&width=1200&height=800&seq=guachi-a2&orientation=landscape",
    tags: ["综艺", "阵容", "慢综艺"],
    content: [
      "据接近节目组的知情人士透露，《一起去远方》第三季已于上周在西南山区低调开录，本季共六位常驻嘉宾，包含两位演员、两位歌手和两位喜剧人。",
      "与上一季的纯旅行模式不同，本季加入了「半程换队友」的机制。嘉宾需要在有限预算内完成任务，才能解锁下一段旅程的交通方式，节奏会比前两季更紧凑。",
      "从目前流出的飞行嘉宾名单看，节目组明显在照顾不同圈层的观众喜好，既有话题度高的流量艺人，也有口碑扎实的实力派。",
      "首期预计在十月上线。至于这份名单是否完全准确，节目组暂未回应，「独家吃瓜」会在官宣后第一时间更新。",
    ],
  },
  {
    id: "a3",
    title: "林知遥直播回应争议：「有些事不需要解释，做好自己就行」",
    excerpt:
      "面对连日来的舆论风波，林知遥在昨晚的直播中首次正面回应，短短七分钟的表态冲上热搜，弹幕风向出现明显反转。",
    category: "influencer",
    categoryName: "网红热榜",
    author: "热榜编辑部",
    date: "2026-09-09",
    time: "22:05",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=young%20asian%20woman%20streaming%20live%20in%20a%20warmly%20lit%20modern%20room%2C%20ring%20light%20glow%2C%20soft%20amber%20and%20coral%20tones%2C%20lifestyle%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=guachi-a3&orientation=landscape",
    tags: ["直播", "回应", "热搜"],
    content: [
      "昨晚的直播原本只是一场常规的好物分享，开播半小时后，林知遥主动提起了最近围绕她的争议，直播间的在线人数瞬间从八万涨到二十七万。",
      "她没有逐条反驳，只用了七分钟说明自己的态度：「有些事不需要解释，做好自己就行。」随后便切回正题继续介绍产品。",
      "有细心的观众截下了她说话时的表情，认为语气平静、没有情绪化，反而是这种克制让不少路人转了粉。",
      "截至发稿，相关话题的阅读量已经突破两亿。她本人暂未再发长文补充，团队表示后续会以作品回应。",
    ],
  },
  {
    id: "a4",
    title: "沈砚舟被曝低调进组刑侦剧，为角色减重十二斤",
    excerpt:
      "据剧组工作人员透露，沈砚舟为新剧角色进行了为期六周的体能训练与饮食控制，进组当天整个人小了一圈，敬业程度被同组演员点赞。",
    category: "hot-gossip",
    categoryName: "明星八卦",
    author: "瓜田观察员",
    date: "2026-09-09",
    time: "17:30",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=chinese%20male%20actor%20in%20dark%20coat%20standing%20in%20a%20dim%20urban%20alley%20at%20dusk%2C%20cinematic%20moody%20lighting%2C%20teal%20and%20warm%20orange%20contrast%2C%20film%20noir%20atmosphere&width=1200&height=800&seq=guachi-a4&orientation=landscape",
    tags: ["进组", "刑侦剧", "敬业"],
    content: [
      "沈砚舟的新剧是一部现代刑侦题材，他在其中饰演一名常年跑外勤的刑警。为了让状态更贴近角色，他在开拍前六周就开始了系统训练。",
      "据同组演员描述，进组那天他的脸颊明显收了，整体看上去比之前清瘦不少，但精神状态很好，跟工作人员打招呼时依旧很随和。",
      "剧组的美术和造型也对角色做了调整，服装基本以耐磨、实用的深色外套为主，刻意避开了过于精致的造型。",
      "该剧预计明年上半年播出。从目前透露的制作班底来看，这会是沈砚舟近年来类型跨度较大的一次尝试。",
    ],
  },
  {
    id: "a5",
    title: "古装剧《长夜灯》官宣定档，预告片质感被赞「电影级」",
    excerpt:
      "备受期待的古装剧《长夜灯》正式宣布定档，同步释出的三分钟预告片以冷峻的色调和扎实的置景获得大量好评。",
    category: "screen",
    categoryName: "影视动态",
    author: "追剧小组",
    date: "2026-09-08",
    time: "20:18",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20lantern%20lit%20courtyard%20at%20night%2C%20ancient%20architecture%2C%20deep%20teal%20night%20sky%20with%20warm%20amber%20lantern%20glow%2C%20cinematic%20period%20drama%20still&width=1200&height=800&seq=guachi-a5&orientation=landscape",
    tags: ["定档", "古装", "预告"],
    content: [
      "《长夜灯》官宣定档的消息发布不到一小时，相关话题就冲上了热搜前排。三分钟的预告片没有堆砌大场面，而是用长镜头和自然光交代人物关系。",
      "从画面看，剧组在京郊搭建了主场景，屋檐、灯笼、石阶都做了做旧处理，避免了棚拍常见的塑料感。",
      "配乐方面启用了大量民乐实录，主题旋律在预告片尾出现时层次分明，与画面情绪贴合度较高。",
      "主创在发布会上表示，这部剧想讲的是「普通人在时代里的选择」，因此刻意弱化了玄幻元素，希望观众能沉下心来看人物。",
    ],
  },
  {
    id: "a6",
    title: "《星厨营业中》录制现场突发状况，嘉宾临时互换厨房",
    excerpt:
      "美食综艺《星厨营业中》最新一期录制中途遇到设备故障，节目组临时调整流程，两组嘉宾交换厨房，意外碰撞出不少笑点。",
    category: "variety",
    categoryName: "综艺爆料",
    author: "综艺情报站",
    date: "2026-09-08",
    time: "14:02",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=busy%20open%20kitchen%20in%20a%20warm%20lit%20restaurant%2C%20chefs%20cooking%20with%20fresh%20ingredients%2C%20amber%20and%20coral%20warm%20tones%2C%20food%20documentary%20photography&width=1200&height=800&seq=guachi-a6&orientation=landscape",
    tags: ["美食综艺", "录制", "突发"],
    content: [
      "据现场观众爆料，当天录制进行到第二轮时，其中一组灶台突然断电，节目组在十分钟内做出了调整方案：两组嘉宾互换厨房。",
      "这个临时改动反而让节目出现了意想不到的化学反应，习惯精致摆盘的一组被迫使用最朴素的工具，而另一组则拿到了平时用不上的专业设备。",
      "有嘉宾在采访区笑称，「换厨房比换队友还难」，但成品出人意料地好，评委给出了本季目前最高的分数。",
      "节目组后续回应称，安全流程没有问题，这次调整是为了保证录制顺利。该期内容将在下周与观众见面。",
    ],
  },
  {
    id: "a7",
    title: "短视频达人「阿觅」单月涨粉四百万，方言配音成流量密码",
    excerpt:
      "以方言配音走红的创作者「阿觅」在过去一个月涨粉超过四百万，她的内容不追求精美制作，却凭借真实的生活感打动了大批观众。",
    category: "influencer",
    categoryName: "网红热榜",
    author: "热榜编辑部",
    date: "2026-09-07",
    time: "11:26",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=young%20creator%20recording%20a%20short%20video%20with%20a%20phone%20tripod%20in%20a%20cozy%20home%20studio%2C%20warm%20afternoon%20light%2C%20amber%20and%20cream%20tones%2C%20lifestyle%20photography&width=1200&height=800&seq=guachi-a7&orientation=landscape",
    tags: ["涨粉", "方言", "短视频"],
    content: [
      "「阿觅」的作品时长普遍在四十秒以内，内容大多来自日常生活的片段，再用方言重新配音，节奏轻快、笑点密集。",
      "她本人在采访中提到，自己一开始只是拍给家里人看，没想到方言的亲切感会引发这么大范围的共鸣。",
      "数据平台显示，她近三十天的完播率稳定在六成以上，这个数字在同类账号中相当突出。",
      "目前已有多个品牌与她接触，但她在直播中表示，会优先保证内容的真实感，不会为了数量牺牲质量。",
    ],
  },
  {
    id: "a8",
    title: "宋亦白顾清和工作室同日发声明，否认合作片场不和传闻",
    excerpt:
      "针对网络上流传的「片场不和」说法，宋亦白与顾清和两家工作室在同一天先后发布声明，措辞克制但态度明确。",
    category: "hot-gossip",
    categoryName: "明星八卦",
    author: "瓜田观察员",
    date: "2026-09-07",
    time: "10:05",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=two%20chinese%20actors%20standing%20side%20by%20side%20on%20a%20bright%20modern%20film%20set%2C%20neutral%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20clean%20background&width=1200&height=800&seq=guachi-a8&orientation=landscape",
    tags: ["声明", "合作", "辟谣"],
    content: [
      "两家工作室的声明几乎在同一时间段发布，核心内容一致：合作期间双方相处融洽，所谓「片场不和」纯属子虚乌有。",
      "有业内人士分析，这类传闻往往来自路透照片的过度解读，一张休息时的抓拍就容易被加工成完整的故事线。",
      "从已经公开的花絮来看，宋亦白与顾清和在片场确实有不少互动，包括一起对戏和分享零食的画面。",
      "两位艺人本人未再单独回应，团队呼吁外界把注意力放回作品本身。相关剧集目前仍在后期制作阶段。",
    ],
  },
  {
    id: "a9",
    title: "《雾港来信》口碑逆跌，慢节奏叙事为何越看越上头",
    excerpt:
      "开播首周口碑平平的《雾港来信》，在更新到第八集后评分明显回升，越来越多观众开始为这部剧的耐心叙事买单。",
    category: "screen",
    categoryName: "影视动态",
    author: "追剧小组",
    date: "2026-09-06",
    time: "21:40",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=foggy%20harbor%20town%20at%20dawn%20with%20old%20wooden%20piers%20and%20small%20boats%2C%20muted%20teal%20and%20warm%20cream%20tones%2C%20atmospheric%20cinematic%20landscape&width=1200&height=800&seq=guachi-a9&orientation=landscape",
    tags: ["口碑", "悬疑", "剧评"],
    content: [
      "《雾港来信》的开局并不讨巧，前四集节奏缓慢，大量篇幅用在环境交代和人物铺垫上，不少观众在评论区表示「差点弃剧」。",
      "转折出现在第六集，此前埋下的细节开始互相咬合，观众回看前几集才发现很多看似闲笔的镜头其实都有意义。",
      "剧集在摄影上刻意保留了海岸线的潮湿质感，大量使用自然光和长焦镜头，形成了与其他同类型作品不同的气质。",
      "有评论认为，这部剧真正想讨论的是记忆与和解，悬疑只是外壳。随着剧情推进，它的受众会更精准，口碑也更具黏性。",
    ],
  },
  {
    id: "a10",
    title: "《快乐出发吧》新一季定档，素人嘉宾比例提升引发讨论",
    excerpt:
      "老牌户外综艺《快乐出发吧》公布新一季阵容，首次将素人嘉宾比例提升到一半，节目组称希望「把镜头还给普通人」。",
    category: "variety",
    categoryName: "综艺爆料",
    author: "综艺情报站",
    date: "2026-09-06",
    time: "15:12",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=diverse%20group%20of%20young%20people%20playing%20outdoor%20team%20games%20on%20a%20sunny%20grassy%20field%2C%20warm%20golden%20light%2C%20joyful%20documentary%20photography&width=1200&height=800&seq=guachi-a10&orientation=landscape",
    tags: ["定档", "素人", "户外"],
    content: [
      "节目组在发布会上确认，新一季将引入六位素人嘉宾，与常驻艺人组成能力互补的队伍，素人比例达到一半。",
      "制片人解释，这个调整的出发点是希望节目不再只围绕艺人个人光环，而是让真实的生活经验和技能成为看点。",
      "首期录制的主题是「城市之外」，嘉宾需要在一天内完成物资采集与营地搭建，过程中出现了不少真实的手忙脚乱。",
      "从观众反馈看，这个改动褒贬不一，但大多数人对「不靠剧本」的尝试表示支持。节目将于本月末开播。",
    ],
  },
  {
    id: "a11",
    title: "达人「一禾」转型做长视频，首支作品播放量破两千万",
    excerpt:
      "以十五秒卡点视频起家的创作者「一禾」，近日发布了一支二十五分钟的纪录短片，播放量在三天内突破两千万。",
    category: "influencer",
    categoryName: "网红热榜",
    author: "热榜编辑部",
    date: "2026-09-05",
    time: "19:48",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=young%20filmmaker%20editing%20footage%20on%20a%20laptop%20in%20a%20warm%20minimal%20studio%2C%20amber%20desk%20lamp%20glow%2C%20cinematic%20behind%20the%20scenes%20photography&width=1200&height=800&seq=guachi-a11&orientation=landscape",
    tags: ["转型", "长视频", "纪录"],
    content: [
      "「一禾」此前以节奏明快的卡点视频为人熟知，这次却选择了完全相反的路线：一支二十五分钟、几乎没有剪辑技巧的纪录短片。",
      "短片记录的是她家乡一位老手艺人的日常，全片没有旁白，只有环境声和人物对话，风格朴素得让不少老粉意外。",
      "数据显示，这支作品的完播率虽然不如她过往的短视频，但评论区的讨论质量明显更高。",
      "她在片尾说，做长视频的念头存了两年，这次算是给自己一个交代。至于是否继续，她说要看观众的真实反馈。",
    ],
  },
  {
    id: "a12",
    title: "新人演员程屿凭配角出圈，一段三分钟独白被反复剪辑",
    excerpt:
      "在某热播剧中饰演男三号的程屿，因为一段三分钟的独白戏份意外走红，相关片段的二次创作量在两天内突破十万条。",
    category: "hot-gossip",
    categoryName: "明星八卦",
    author: "瓜田观察员",
    date: "2026-09-05",
    time: "13:20",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=young%20chinese%20male%20actor%20performing%20an%20emotional%20monologue%20under%20a%20single%20spotlight%2C%20dramatic%20warm%20stage%20lighting%2C%20dark%20background%2C%20cinematic%20portrait&width=1200&height=800&seq=guachi-a12&orientation=landscape",
    tags: ["出圈", "配角", "演技"],
    content: [
      "这段独白出现在剧集第二十七集，程屿饰演的角色在雨夜里讲述自己的身世，全程一个长镜头，没有多余运镜。",
      "不少观众在弹幕里表示「没认出来这是配角」，他的表演被认为是全剧的高光时刻之一。",
      "程屿本人在采访中坦承，这场戏拍了九条，导演一直在帮他寻找更收着的表达方式，「最后一条其实最不像在演」。",
      "入行五年，这是他第一次真正被大众记住名字。他笑称，接下来还是要一部一部地拍，不着急。",
    ],
  },
  {
    id: "a13",
    title: "动画电影《山与海之间》票房破十亿，成人向叙事获认可",
    excerpt:
      "国产动画电影《山与海之间》上映第十天票房突破十亿，这部没有低幼化处理的作品，让「成人向动画」再次成为行业热词。",
    category: "screen",
    categoryName: "影视动态",
    author: "追剧小组",
    date: "2026-09-04",
    time: "16:55",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=animated%20mountain%20and%20sea%20landscape%20in%20warm%20golden%20and%20teal%20tones%2C%20stylized%20painterly%20illustration%20style%2C%20epic%20emotional%20cinematic%20scene&width=1200&height=800&seq=guachi-a13&orientation=landscape",
    tags: ["动画", "票房", "口碑"],
    content: [
      "《山与海之间》上映十天票房破十亿，这个成绩在非低幼定位的国产动画里相当少见。",
      "影片上映前的宣传并不张扬，靠的是先看过的一批观众自发安利。很多人提到，电影对「告别」这一主题的处理克制而真诚。",
      "制作团队在幕后采访中透露，全片手绘镜头占比超过七成，光是片尾海面的三分钟动画就绘制了近八个月。",
      "有院线经理表示，这部电影的观众年龄结构比预期更成熟，周末场次里亲子观众反而不到三成。",
    ],
  },
  {
    id: "a14",
    title: "《深夜书店》第二季回归，主持人阵容迎来首次调整",
    excerpt:
      "以深夜对谈为主打的《深夜书店》宣布第二季回归，主持阵容迎来开播以来的第一次调整，新增一位青年编剧担任常驻。",
    category: "variety",
    categoryName: "综艺爆料",
    author: "综艺情报站",
    date: "2026-09-04",
    time: "09:30",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20late%20night%20bookstore%20interior%20with%20warm%20amber%20lamps%20and%20wooden%20shelves%2C%20person%20reading%20quietly%2C%20intimate%20soft%20lighting%20photography&width=1200&height=800&seq=guachi-a14&orientation=landscape",
    tags: ["对谈", "回归", "调整"],
    content: [
      "《深夜书店》以安静的深夜对谈著称，第二季最大的变化是新增了一位青年编剧作为常驻主持。",
      "节目组表示，这次调整是为了让对谈视角更多元，既有成熟媒体的提问方式，也有创作者之间的同行共鸣。",
      "首期嘉宾是一位专注于小剧场创作的导演，两人聊到凌晨两点才收工，现场几乎没有用提词器。",
      "第二季仍保持每周一集的更新节奏，录制地点换成了一家仍在营业的旧书店，环境声被完整保留了下来。",
    ],
  },
  {
    id: "a15",
    title: "美食博主「老白下厨」线下开店，首日排队超三小时",
    excerpt:
      "拥有千万粉丝的美食博主「老白下厨」在老家开出第一家实体小店，主打家常菜，开业首日排队时间超过三小时。",
    category: "influencer",
    categoryName: "网红热榜",
    author: "热榜编辑部",
    date: "2026-09-03",
    time: "18:10",
    readTime: "3 分钟",
    image:
      "https://readdy.ai/api/search-image?query=small%20cozy%20home%20style%20restaurant%20with%20warm%20wooden%20tables%20and%20homemade%20dishes%2C%20amber%20evening%20light%2C%20appetizing%20food%20photography&width=1200&height=800&seq=guachi-a15&orientation=landscape",
    tags: ["线下", "开店", "美食"],
    content: [
      "「老白下厨」的视频一向以「在家也能做」著称，这次他把视频里的家常菜搬到了实体店里，菜单只有十二道。",
      "开业首日，门店外排起了长队，不少顾客是从外地专程赶来，等待时间普遍超过三小时。",
      "老白在店里接受了简短采访，说定价刻意压得比较低，希望附近居民平时也能来吃。",
      "不过他也在直播里坦言，开店的难度远超预期，后厨效率和短视频完全是两回事，接下来会先稳住出品再考虑扩张。",
    ],
  },
  {
    id: "a16",
    title: "音乐人周叙白回归舞台，新专辑主打歌首唱引全场大合唱",
    excerpt:
      "沉寂两年的音乐人周叙白带着新专辑回归，巡演首站的主打歌首唱环节，全场观众自发大合唱，场面相当感人。",
    category: "hot-gossip",
    categoryName: "明星八卦",
    author: "瓜田观察员",
    date: "2026-09-03",
    time: "12:00",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=musician%20performing%20on%20stage%20with%20warm%20amber%20spotlights%20and%20silhouetted%20crowd%2C%20emotional%20concert%20photography%2C%20dark%20warm%20atmosphere&width=1200&height=800&seq=guachi-a16&orientation=landscape",
    tags: ["回归", "巡演", "新专辑"],
    content: [
      "周叙白已经两年没有公开演出，这次巡演首站开票即售罄，现场来了不少从早年就一路追随的歌迷。",
      "主打歌首唱时，他刚唱完第一段，台下就自发接上了副歌，声音整齐得让他一度停下来听观众唱完。",
      "新专辑延续了他一贯的叙事风格，歌词更偏向个人经验，编曲上减少了电子元素，加入了更多弦乐实录。",
      "他在台上说，这两年最大的收获是学会了慢下来，「有些歌急不得」。巡演接下来还会去到六座城市。",
    ],
  },
];

export const quickNews = [
  { time: "09:12", text: "江迟苏念新剧片场路透流出，两人候场对台词被赞默契" },
  { time: "08:40", text: "《一起去远方》第三季阵容曝光，六位嘉宾反差拉满" },
  { time: "08:02", text: "古装剧《长夜灯》官宣定档，三分钟预告片质感获好评" },
  { time: "07:35", text: "短视频达人「阿觅」单月涨粉四百万，方言配音成流量密码" },
  { time: "07:10", text: "沈砚舟低调进组刑侦剧，为角色减重十二斤" },
  { time: "06:48", text: "《雾港来信》口碑逆跌，第八集后评分明显回升" },
  { time: "06:20", text: "宋亦白顾清和工作室同日发声明，否认片场不和传闻" },
  { time: "05:55", text: "音乐人周叙白回归舞台，主打歌首唱引全场大合唱" },
];

export interface HotTopic {
  rank: number;
  title: string;
  heat: string;
  trend: "up" | "down" | "flat";
  articleId: string;
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: "江迟苏念同框路透流出", heat: "486.2万", trend: "up", articleId: "a1" },
  { rank: 2, title: "一起去远方第三季阵容", heat: "372.8万", trend: "up", articleId: "a2" },
  { rank: 3, title: "林知遥直播回应争议", heat: "310.5万", trend: "up", articleId: "a3" },
  { rank: 4, title: "沈砚舟减重十二斤进组", heat: "268.1万", trend: "flat", articleId: "a4" },
  { rank: 5, title: "长夜灯定档预告质感", heat: "221.6万", trend: "up", articleId: "a5" },
  { rank: 6, title: "阿觅方言配音涨粉", heat: "198.4万", trend: "down", articleId: "a7" },
  { rank: 7, title: "雾港来信口碑逆跌", heat: "176.9万", trend: "up", articleId: "a9" },
  { rank: 8, title: "程屿三分钟独白出圈", heat: "152.3万", trend: "up", articleId: "a12" },
];

export const onScene = [
  {
    id: "s1",
    title: "《长夜灯》发布会现场",
    desc: "主创集体亮相，导演现场回应观众最关心的改编尺度问题。",
    image:
      "https://readdy.ai/api/search-image?query=press%20conference%20stage%20with%20warm%20amber%20lighting%20and%20red%20curtain%20backdrop%2C%20empty%20microphone%20podium%2C%20cinematic%20event%20photography&width=900&height=600&seq=guachi-scene1&orientation=landscape",
    tag: "发布会",
  },
  {
    id: "s2",
    title: "《一起去远方》山区录制",
    desc: "清晨五点出发，嘉宾在雾气未散的山道上完成第一段徒步。",
    image:
      "https://readdy.ai/api/search-image?query=misty%20mountain%20trail%20at%20early%20morning%20with%20hikers%20silhouettes%2C%20soft%20golden%20fog%2C%20documentary%20landscape%20photography&width=900&height=600&seq=guachi-scene2&orientation=landscape",
    tag: "路透",
  },
  {
    id: "s3",
    title: "周叙白巡演后台",
    desc: "开演前一小时的后台走廊，乐手们在做最后的调音确认。",
    image:
      "https://readdy.ai/api/search-image?query=concert%20backstage%20corridor%20with%20warm%20dimmer%20lights%20and%20guitar%20cases%2C%20moody%20intimate%20photography&width=900&height=600&seq=guachi-scene3&orientation=landscape",
    tag: "幕后",
  },
  {
    id: "s4",
    title: "老白下厨门店开业",
    desc: "开放后厨里，十二道家常菜依次出锅，蒸汽把玻璃蒙上一层雾。",
    image:
      "https://readdy.ai/api/search-image?query=open%20kitchen%20with%20steaming%20homestyle%20dishes%20on%20a%20warm%20wooden%20counter%2C%20amber%20lighting%2C%20appetizing%20food%20photography&width=900&height=600&seq=guachi-scene4&orientation=landscape",
    tag: "现场",
  },
];

export const faqs = [
  {
    q: "「独家吃瓜」的内容多久更新一次？",
    a: "网站首页的快讯滚动播报保持工作日高频更新，早间、午间和晚间各有一轮集中采编。热点事件会以快讯形式即时补充，深度解读则集中在每日晚间整理成文。",
  },
  {
    q: "网站上的信息来自哪里？会不会有未经证实的传闻？",
    a: "我们只整理公开可查的信息来源，并在文中标注时间与出处类型。对于尚未官方确认的内容，会在标题或正文中明确提示「疑似」「网传」，不做确定性表述，也欢迎读者通过联系页面向我们反馈。",
  },
  {
    q: "如何第一时间收到最新的娱乐快讯？",
    a: "订阅首页底部的爆料通讯即可。我们会把当天最值得关注的几条动态和深度解读整理成邮件，每周发送一到两次，不会频繁打扰。",
  },
  {
    q: "可以在网站上找到过往的文章吗？",
    a: "可以。全部快讯列表页支持按分类筛选和关键词搜索，你也可以从任意文章底部的相关推荐继续往下逛。分类页则更适合按「明星八卦」「综艺爆料」「影视动态」「网红热榜」四个方向系统浏览。",
  },
  {
    q: "如果发现内容有误，应该怎么处理？",
    a: "请通过联系我们页面的表单说明具体文章和问题，我们会在核实后尽快更正。涉及当事人澄清的内容，我们会优先处理并在文中标注更新记录。",
  },
];